import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatUSD(value: number | null | undefined): string {
  if (value == null) return ''
  const abs = Math.abs(value)
  if (abs >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(2)}B`
  if (abs >= 1_000_000) return `$${(value / 1_000_000).toFixed(2)}M`
  if (abs >= 1_000) return `$${(value / 1_000).toFixed(2)}K`
  return `$${value.toFixed(2)}`
}

export function formatCompact(value: number | null | undefined): string {
  if (value == null) return ''
  const abs = Math.abs(value)
  if (abs >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(2)}B`
  if (abs >= 1_000_000) return `${(value / 1_000_000).toFixed(2)}M`
  if (abs >= 1_000) return `${(value / 1_000).toFixed(2)}K`
  return value.toFixed(2)
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null) return ''
  const sign = value >= 0 ? '+' : ''
  return `${sign}${value.toFixed(2)}%`
}

export function extractBaseSymbol(symbol: string): string {
  if (!symbol) return ''
  const s = symbol.toUpperCase()
  if (s.includes('/')) return s.split('/')[0]
  if (s.includes('-USDT')) return s.split('-USDT')[0]
  if (s.includes('_USDT')) return s.split('_USDT')[0]
  if (s.endsWith('USDT')) return s.slice(0, -4)
  if (s.includes('-USD')) return s.split('-USD')[0]
  if (s.includes('_USD')) return s.split('_USD')[0]
  if (s.endsWith('USD')) return s.slice(0, -3)
  return s
}

export function buildCoinglassUrl(exchange: string, base: string): string {
  const ex = exchange.toLowerCase()
  const b = extractBaseSymbol(base)
  if (!b) return 'https://www.coinglass.com/'
  
  const urls: Record<string, string> = {
    bitget: `https://www.coinglass.com/tv/Bitget_${b}USDT_UMCBL`,
    bybit: `https://www.coinglass.com/tv/Bybit_${b}USDT`,
    okx: `https://www.coinglass.com/tv/OKX_${b}-USDT-SWAP`,
    gate: `https://www.coinglass.com/tv/Gate_${b}_USDT`,
    kucoin: `https://www.coinglass.com/tv/Kucoin_${b}USDTM`,
    mexc: `https://www.coinglass.com/tv/MEXC_${b}_USDT`,
  }
  
  return urls[ex] || `https://www.coinglass.com/tv/${ex.toUpperCase()}_${b}USDT`
}

export function getRelativeTime(timestamp: number): string {
  const now = Date.now()
  const diff = now - timestamp * 1000
  
  if (diff < 60000) return 'just now'
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`
  return `${Math.floor(diff / 86400000)}d ago`
}
